// extracted by mini-css-extract-plugin
module.exports = {"title":"FaqPage_title__1vTyX","collapse":"FaqPage_collapse__2LOK1","panel":"FaqPage_panel__1AB3W","icon":"FaqPage_icon__1fpKd","action":"FaqPage_action__7z0VJ"};